import ApiService from './api.service';

const PatientService = {
  getSurveyData: async () => {
    return ApiService.fetch('patient/survey');
  },

  getAll: () => ApiService.fetch('patients/all'),

  submitSurvey: async (surveyData) => {
    return ApiService.fetch('patient/survey', {
      method: 'POST',
      body: JSON.stringify(surveyData)
    });
  },

  updateProfile: (data) => ApiService.fetch('patient/profile', {
    method: 'PUT',
    body: JSON.stringify({
      first_name: data.first_name,
      last_name: data.last_name,
      birth_date: data.birth_date,
      birth_place: data.birth_place,
      fiscal_code: data.cf, // Mappa cf -> fiscal_code per users
      gender: data.gender,
      // Campi indirizzo
      address: data.address,        // Campo generico (mantenuto)
      street: data.street,          // Via
      civic_number: data.civic_number, // Numero civico
      postal_code: data.postal_code,   // CAP
      city: data.city,              // Città
      province: data.province,      // Provincia
      phone: data.phone,
      medical_history: data.medical_history,
      pi: data.pi,
      invio_fattura_sistema_sanitaria: data.invio_fattura_sistema_sanitaria
    })
  }),

  updatePassword: (passwordData) => ApiService.fetch('patient/update-password', {
    method: 'POST',
    body: JSON.stringify(passwordData)
  }),

  getProfile: () => ApiService.fetch('patient/profile'),

  checkBookingEligibility: () => ApiService.fetch('patient/booking-eligibility'),
};

export default PatientService;